import React from 'react';

import { Headline, BodyCopy } from '@xingternal/typography';
import { IconArrowRight } from '@xingternal/icons';
import { FormattedMessage } from 'react-intl';
import { CompanyCard } from '@/components/CompanyCard';
import { Link } from 'react-router-dom';

import styles from './LoggedOutLandingPage.css';
import { Company } from '@/types/graphql-types';

type CompaniesRowProps = {
  companies: Company[];
  totalCaption: string;
  showAllLink: string;
  title: string;
};

const CompaniesRow: React.FC<CompaniesRowProps> = ({
  companies,
  totalCaption,
  showAllLink,
  title,
}) => {
  return (
    <section className={styles.companiesRow}>
      <Headline size="large" className={styles.companiesTitle}>
        <FormattedMessage id={title} />
      </Headline>
      <div className={styles.companiesContainer}>
        {companies.map((company) => (
          <div className={styles.wrapper} key={company?.id}>
            <CompanyCard className={styles.card} company={company} />
          </div>
        ))}
        <div className={styles.viewMore}>
          <div className={styles.viewMoreInner}>
            <Link to={showAllLink} className={styles.viewMoreLink}>
              <BodyCopy
                fontWeight="bold"
                size="medium"
                className={styles.viewMoreCaption}
              >
                <FormattedMessage
                  id={totalCaption}
                  values={
                    {
                      span: (...text: any[]) => (
                        <span className={styles.viewMoreCaptionHighlight}>
                          {text}
                        </span>
                      ),
                    } as unknown as Record<string, React.ReactNode>
                  }
                />
                <br />
                <IconArrowRight
                  width="24"
                  height="24"
                  className={styles.viewMoreIcon}
                />
              </BodyCopy>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
export { CompaniesRow };
